import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BaseComponent } from '@app/components/base/base.component';
import { DiroResponseDto } from '../../model/open-quote.model';
import { environment } from '@env//environment.local';

// Cambio para merge
@Component({
  template: '',
})
export class CalculateDiroOpenQuoteWrapper
  extends BaseComponent
  implements OnInit
{
  @Input() set profitDeal(value: any) {
    if (this._profitDeal) {
      let dto = {
        id: value?.id ? value?.id : null,
        creationDate: value.creationDate || null,
      };
      if (this._profitDeal.urlQuote && this._profitDeal.urlDeal) {
        this.urlQuote = this._profitDeal.urlQuote;
        this.urlDeal = this._profitDeal.urlDeal;
      }
      this.form.patchValue(dto);
    } else {
      this.form.patchValue(value);
      this.form.controls['createOn'].setValue(
        this.getMonthAndYear(this.form.controls['createOn'].value)
      );
      this.form.controls['calculationOf'].setValue(
        this.getMonthAndYear(this.form.controls['calculationOf'].value)
      );
      this.form.controls['interestAsOf'].setValue(
        this.getMonthAndYear(this.form.controls['interestAsOf'].value)
      );
      this.form.controls['spreadsAsOf'].setValue(
        this.getMonthAndYear(this.form.controls['spreadsAsOf'].value)
      );
    }
    this._profitDeal = value;
  }

  @Output() updateDataDiro: EventEmitter<any> = new EventEmitter();
  urlQuote: any;
  urlDeal: any;
  private _profitDeal: any;
  form: FormGroup;
  @ViewChild('hiddenCustomerInstallment') hiddenCustomerInstallment: ElementRef;
  private readonly fb = inject(FormBuilder);

  constructor() {
    super();
    this.createForm();
  }

  ngOnInit() {}

  createForm() {
    this.form = this.fb.group({
      id: [, []],
      creationDate: [, []],
      customerRateEffective: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      customerRateNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      iDcsSubsidiesFeesNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      dealRateEffective: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      dealRateNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      costOfDebtNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      grossInterestMarginEffective: [
        ,
        [Validators.pattern(/^\d+(\.\d{1,2})?$/)],
      ],
      grossInterestMarginNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      capitalAdvantageNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      netInterestMarginEffective: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      netInterestMarginNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      standardCostOfCreditRiskNominal: [
        ,
        [Validators.pattern(/^\d+(\.\d{1,2})?$/)],
      ],
      opexNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      freeSubsNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      netEbItMarginEffective: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      netEbItMarginNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      economicCapitalNominal: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      plf: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      pls: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      dfsMasterScale: [, [Validators.pattern(/^\d+$/)]],
      effectiveMaturity: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      customerInstallment: [, [Validators.pattern(/^[\d,.]+$/)]],
      calculationOf: ['', []],
      interestAsOf: ['', []],
      spreadsAsOf: ['', []],
      createOn: ['', []],
      idQuote: ['', []],
      idDeal: ['', []],
    });

    this.form.valueChanges.subscribe((value) => {
      this.updateDataDiro.emit(this.form.value);
    });
  }

  formatNumber() {
    let value = this.form.controls['customerInstallment'].value;

    if (!value) return;
    value = this.unformatInputValue(value);
    this.form.controls['customerInstallment'].setValue(
      this.formatInputValue(value)
    );
  }

  getMonthAndYear(date: string) {
    if (!date) return;
    const newDate = date.slice(0, 10);
    return newDate;
  }

  parseDate(dateInput: string) {
    let out = '';
    if (dateInput && dateInput !== '') {
      let arrDate = dateInput.split('/');
      if (arrDate.length > 0) {
        out = arrDate[2] + '-' + arrDate[1] + '-' + arrDate[0];
      }
    }
    return out;
  }

  setDataFromDiro(diroResponseDto: DiroResponseDto) {
    if (!environment.activarDiro) return;
    if (diroResponseDto) {
      this.form.controls['customerRateEffective'].setValue(
        diroResponseDto!.customerRateIn
      );
      this.form.controls['customerRateNominal'].setValue(
        diroResponseDto!.customerRateInNom
      );
      this.form.controls['iDcsSubsidiesFeesNominal'].setValue(
        diroResponseDto!.idCsSubsidiesFeesUpfront
      );
      this.form.controls['dealRateEffective'].setValue(
        diroResponseDto!.dealRateIrr
      );
      this.form.controls['dealRateNominal'].setValue(
        diroResponseDto!.dealRateIrrNom
      );
      this.form.controls['costOfDebtNominal'].setValue(
        diroResponseDto!.costOfDebt100MatchedFunded
      );
      this.form.controls['grossInterestMarginEffective'].setValue(
        diroResponseDto!.grossInterestMargin
      );
      this.form.controls['grossInterestMarginNominal'].setValue(
        diroResponseDto!.grossInterestMarginNom
      );
      this.form.controls['capitalAdvantageNominal'].setValue(
        diroResponseDto!.capitalAdvantage
      );
      this.form.controls['netInterestMarginEffective'].setValue(
        diroResponseDto!.netInterestMargin
      );
      this.form.controls['netInterestMarginNominal'].setValue(
        diroResponseDto!.netInterestMarginNom
      );
      this.form.controls['standardCostOfCreditRiskNominal'].setValue(
        diroResponseDto!.standardCostOfCreditRisk
      );
      this.form.controls['opexNominal'].setValue(diroResponseDto!.opex);
      this.form.controls['freeSubsNominal'].setValue(
        diroResponseDto!.feesSubsPeriodicRvEndLease
      );
      this.form.controls['netEbItMarginEffective'].setValue(
        diroResponseDto!.netEbitMargin
      );
      this.form.controls['netEbItMarginNominal'].setValue(
        diroResponseDto!.netEbitMarginNom
      );
      this.form.controls['economicCapitalNominal'].setValue(
        diroResponseDto!.economicCapital
      );
      this.form.controls['plf'].setValue(diroResponseDto!.plfGuar);
      this.form.controls['pls'].setValue(diroResponseDto!.pls);
      this.form.controls['dfsMasterScale'].setValue(
        diroResponseDto!.dfsMasterScale
      );
      this.form.controls['effectiveMaturity'].setValue(
        diroResponseDto!.effectiveMaturity
      );
      this.form.controls['customerInstallment'].setValue(
        diroResponseDto!.customerInstallment
      );
      this.form.controls['calculationOf'].setValue(
        this.parseDate(diroResponseDto!.calculationAsOf)
      );
      this.form.controls['interestAsOf'].setValue(
        this.parseDate(diroResponseDto!.interestAsOf)
      );
      this.form.controls['spreadsAsOf'].setValue(
        this.parseDate(diroResponseDto!.spreadsAsOf)
      );
      this.form.controls['createOn'].setValue(
        this.parseDate(diroResponseDto!.createdOn)
      );
      this.form.controls['idQuote'].setValue(diroResponseDto!.idQuote);
      this.form.controls['idDeal'].setValue(diroResponseDto!.idDeal);
      this.hiddenCustomerInstallment.nativeElement.value =
        diroResponseDto!.customerInstallment;
      this.urlQuote = diroResponseDto.urlQuote;
      this.urlDeal = diroResponseDto.urlDeal;
    }
  }

  isExpanded = false; // Inicialmente colapsado

  toggleAccordion(): void {
    this.isExpanded = !this.isExpanded; // Alterna el estado
  }

  // getters
  get netInterestMarginEffective(){
    return this.form.controls['netInterestMarginEffective'].value || 0;
  }

  get netInterestMarginNominal(){
    return this.form.controls['netInterestMarginNominal'].value || 0;
  }
}
